import { Box, FormControl, FormLabel } from "@mui/material";
import { SmartDatePicker, SmartTextField } from "@nodeon/react-components";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { AtonsFaultSearchForm } from "../tabs/AtonsFaultSearchTab";
import { SharedFormProps } from "../WaterTrafficSignContainers/WaterTrafficSignStateForm";

export type FaultRelatedActivityFormTypes = {
  observedStartDate: Date | null;
  observedEndDate: Date | null;
  entryStartDate: Date | null;
  entryEndDate: Date | null;
  fixedStartDate: Date | null;
  fixedEndDate: Date | null;
  faultDaysMin: number | null;
  faultDaysMax: number | null;
};

export const faultRelatedActivityDefaults: FaultRelatedActivityFormTypes = {
  observedStartDate: null,
  observedEndDate: null,
  entryStartDate: null,
  entryEndDate: null,
  fixedStartDate: null,
  fixedEndDate: null,
  faultDaysMin: 0,
  faultDaysMax: 0,
};

export const FaultRelatedActivityForm = ({ isDisabled }: SharedFormProps) => {
  const { t } = useTranslation("faultRelatedActivityForm");
  const { control } = useFormContext<AtonsFaultSearchForm>();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "10px",
      }}
    >
      <Box sx={{ display: "grid" }}>
        <FormLabel>{t("noticed")}</FormLabel>
        <Box
          sx={{
            display: "grid",
            gap: "10px",
            gridTemplateColumns: "1fr 1fr",
            mt: 0,
          }}
        >
          <SmartDatePicker<AtonsFaultSearchForm>
            controllerProps={{ control }}
            name="observedStartDate"
            label={t("vessels:startTime")}
            disabled={isDisabled}
          />

          <SmartDatePicker<AtonsFaultSearchForm>
            controllerProps={{ control }}
            name="observedEndDate"
            label={t("vessels:endTime")}
            disabled={isDisabled}
          />
        </Box>
      </Box>
      <Box sx={{ display: "grid" }}>
        <FormLabel>{t("registered")}</FormLabel>
        <Box
          sx={{
            display: "grid",
            gap: "10px",
            gridTemplateColumns: "1fr 1fr",
            mt: 0,
          }}
        >
          <SmartDatePicker<AtonsFaultSearchForm>
            controllerProps={{ control }}
            name="entryStartDate"
            label={t("vessels:startTime")}
            disabled={isDisabled}
          />

          <SmartDatePicker<AtonsFaultSearchForm>
            controllerProps={{ control }}
            name="entryEndDate"
            label={t("vessels:endTime")}
            disabled={isDisabled}
          />
        </Box>
      </Box>
      <Box sx={{ display: "grid" }}>
        <FormLabel>{t("fixed")}</FormLabel>
        <Box
          sx={{
            display: "grid",
            gap: "10px",
            gridTemplateColumns: "1fr 1fr",
            mt: 0,
          }}
        >
          <SmartDatePicker<AtonsFaultSearchForm>
            controllerProps={{ control }}
            name="fixedStartDate"
            label={t("vessels:startTime")}
            disabled={isDisabled}
          />

          <SmartDatePicker<AtonsFaultSearchForm>
            controllerProps={{ control }}
            name="fixedEndDate"
            label={t("vessels:endTime")}
            disabled={isDisabled}
          />
        </Box>
      </Box>

      <FormControl disabled={isDisabled}>
        <FormLabel>{t("faultTime")}</FormLabel>
        <Box
          sx={{
            display: "flex",
            gap: "20px",
            minWidth: "170px",
            width: "35%",
          }}
        >
          <SmartTextField<AtonsFaultSearchForm>
            label={t("minPv")}
            name="faultDaysMin"
            type="number"
            fullWidth
            autoComplete="off"
            controllerProps={{ control }}
            // InputProps={{ endAdornment: "V" }}
            disabled={isDisabled}
          />
          {/* <Box>
            <Typography variant="h4">-</Typography>
          </Box> */}

          <SmartTextField<AtonsFaultSearchForm>
            // InputProps={{ endAdornment: "V" }}
            label={t("max")}
            name="faultDaysMax"
            type="number"
            fullWidth
            autoComplete="off"
            controllerProps={{ control }}
            disabled={isDisabled}
          />
        </Box>
      </FormControl>
    </Box>
  );
};
